<script lang="ts">
  import { mdiCheck, mdiClose } from "@mdi/js"
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import InboxActionToggleCell from "../inbox-action-toggle-cell"

  let props: InboxWorkflowCellProps = $props()

  const value = $derived(props.draft.completed === false ? "not_done" : "done")
  const options = [
    {
      value: "done",
      label: "Ja",
      icon: mdiCheck,
      tooltip: "Diese Änderung wurde im Kehrbezirksprogramm nachgezogen.",
    },
    {
      value: "not_done",
      label: "Nein",
      icon: mdiClose,
      tooltip: "Diese Änderung ist im Kehrbezirksprogramm noch offen.",
    },
  ]
</script>

<InboxActionToggleCell
  {value}
  {options}
  disabled={props.binding.disabled}
  ariaLabel={`Kehrbezirksprogramm-Status für ${props.row.id}`}
  onChange={(next) => props.patchDraft({ completed: next === "done" })}
/>
